module.exports = __webpack_public_path__ + "static/media/feedback-white.27e5ba9e.svg";